(function () {
  'use strict';

  function repeat(html, count) {
    var out = '';
    for (var i = 0; i < count; i++) out += html;
    return out;
  }

  /* &nbsp; in each otherwise-empty block: base.css:487 hides div/h4 :empty
     globally (Dawn), so a truly empty placeholder renders display:none. */
  var CARD =
    '<div class="card card--sk" aria-hidden="true">' +
      '<div class="ph sk">&nbsp;<span class="sk-fav"></span></div>' +
      '<div class="add sk"></div>' +
      '<div class="ct sk sk-line">&nbsp;</div>' +
      '<h4 class="sk sk-line">&nbsp;</h4>' +
      '<div class="pr sk sk-line">&nbsp;</div>' +
      '<div class="sw"><span class="sk sw-dot"></span><span class="sk sw-dot"></span><span class="sk sw-dot"></span></div>' +
    '</div>';

  /* rec-item CSS (section-amphr-cart-recommendations.css) is fetched with the
     recs section HTML itself, so it is NOT in the document yet while this
     markup shows. The real classes are kept for when a later, already-loaded
     pass reuses them, but the geometry that matters (rec-item--sk in
     component-skeleton.css) cannot depend on that stylesheet arriving. */
  var REC_ITEM =
    '<div class="rec-item rec-item--sk" aria-hidden="true">' +
      '<div class="rec-item__media sk">&nbsp;</div>' +
      '<div class="rec-item__body">' +
        '<div class="rec-item__title rec-sk-title sk sk-line">&nbsp;</div>' +
        '<div class="rec-item__price rec-sk-price sk sk-line">&nbsp;</div>' +
      '</div>' +
      '<div class="rec-item__add rec-sk-add sk">&nbsp;</div>' +
    '</div>';

  /* /search uses card-product.liquid (Dawn), not product-card.liquid (amphr) — different markup, different geometry.
     card--standard/color-scheme-2/150% are only the fallback for when no real card is in the DOM to read from (opts). */
  function searchCardHtml(opts) {
    var cardStyleClass = (opts && opts.cardStyleClass) || 'card--standard';
    var innerColorClass = (opts && opts.innerColorClass) || 'color-scheme-2 gradient';
    var ratioPercent = (opts && opts.ratioPercent) || '150%';
    return (
      '<li class="grid__item card--sk-search" aria-hidden="true">' +
        '<div class="card-wrapper product-card-wrapper">' +
          '<div class="card ' + cardStyleClass + ' card--media">' +
            '<div class="card__inner ' + innerColorClass + ' ratio" style="--ratio-percent: ' + ratioPercent + ';">' +
              '<div class="card__media"><div class="media media--transparent sk">&nbsp;</div></div>' +
            '</div>' +
            '<div class="card__content">' +
              '<div class="card__information">' +
                '<h3 class="card__heading h5 sk sk-line">&nbsp;</h3>' +
                '<div class="card-information"><span class="pr sk sk-line">&nbsp;</span></div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>'
    );
  }

  window.amphrSkeleton = {
    productCard: function (count) {
      return repeat(CARD, count);
    },
    recItem: function (count) {
      return repeat(REC_ITEM, count);
    },
    searchCard: function (count, opts) {
      return repeat(searchCardHtml(opts), count);
    }
  };
})();
